/* jshint esversion: 6 */
import makeToast from 'app/modules/makeToast.js';

/**
 * Says how a batch of new socials went, once its job has left the batch poll: connected, or how
 * many couldn't be. `job` is the last the poll had of it, whose counts are strings from Redis; a
 * job the poll never saw finish carries only its total, and counts as connected.
 */
export default function reportSocialBatch(job) {
	let total = parseInt(job?.total, 10) || 0,
		failed = parseInt(job?.failure, 10) || 0,
		profiles = (total === 1) ? 'profile' : 'profiles';

	if (failed === 0) {
		makeToast(`Social ${profiles} connected`, "success");
	} else if (failed === total) {
		makeToast(`We couldn't connect your social ${profiles}`, "error");
	} else {
		makeToast(`We couldn't connect ${failed} of your ${total} social profiles`, "error");
	}
}
